const exportMemberChangeMobileTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "OUTLET": "outlet",
    "NAME": "name",
    "OLD MOBILE": "oldMobile",
    "NEW MOBILE": "newMobile"
}
const exportMemberDeleteTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "OUTLET": "outlet",
    "NAME": "name",
    "MOBILE": "newMobile",
}

const exportCommissionItemTblHdr = {
    "NO.": "index",
    "DATE": "createDate",
    "RECEIPT NO.": "receiptID",
    "ITEM": "item.title",
    "ITEM TYPE": "item.type",
    "OUTLET": "outlet",
    "MEMBER NAME": "member.displayName",
    "MOBILE": "member.mobile",
    "PAYMENT": "redeem",
    "AMOUNT": "price",
    "STAFF 1": "staffs.staff1.name",
    "effort1": "staffs.staff1.effort",
    "pctg1": "staffs.staff1.pctg",
    "fee1": "staffs.staff1.fee",
    "STAFF 2": "staffs.staff2.name",
    "effort2": "staffs.staff2.effort",
    "pctg2": "staffs.staff2.pctg",
    "fee2": "staffs.staff2.fee",
    "STAFF 3": "staffs.staff3.name",
    "effort3": "staffs.staff3.effort",
    "pctg3": "staffs.staff3.pctg",
    "fee3": "staffs.staff3.fee",
    "STAFF 4": "staffs.staff4.name",
    "effort4": "staffs.staff4.effort",
    "pctg4": "staffs.staff4.pctg",
    "fee4": "staffs.staff4.fee",
}

const exportCommissionTypeTblHdr = {
    "NO.": "index",
    "ITEM": "title",
    "ITEM TYPE": "type",
    "AMOUNT": "price",
    "sales_effort": "salesEffort",
    "sales_fee": "salesFee",
    "SALES QUANTITY": "salesQty",
    "credits_effort": "creditsEffort",
    "credits_fee": "creditsFee",
    "package_effort": "packageEffort",
    "package_fee": "packageFee",
    "REDEEM QUANTITY": "redeemQty",
    "TOTAL EFFORT": "totalEffort",
    "TOTAL FEE": "totalFee",
    "TOTAL QUANTITY": "totalQty",
}

const exportCommissionCategoryTblHdr = {
    "NO.": "index",
    "OUTLET": "outlet",
    "STAFF": "staff",
    "TYPE": "type",
    "ITEM PRICE": "price",
    "sales_effort": "salesEffort",
    "CREDIT REDEEM": "credits",
    "credits_effort": "creditEffort",
    "PACKAGE REDEEM": "packages",
    "package_effort": "packageEffort",
    "TOTAL EFFORT": "totalEffort",
}

const exportMemberActiveTblHdr = {
    "NO.": "index",
    // "OUTLET": "outlet",
    "NAME": "name",
    "CONTACT": "contact",
    "BIRTHDAY": "birthday",
    "VIP": "vip",
    "VVIP": "vvip",
    "VVVIP": "vvvip",
}

const exportSalesReportItemTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "RECEIPT NO.": "receiptNo",
    "TITLE": "title",
    "OUTLET": "outlet", 
    "MEMBER NAME": "memberName",
    "MOBILE": "mobile", 
    "PRICE": "price",
    "DISCOUNT": "discount",
    "OUTSTANDING": "outstandings",
    "TAX": "tax", 
    "TYPE OF TAX": "taxType",
    "SUBTOTAL": "subtotal"
}

const exportSalesReportDateTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "SERVICE": "service",
    "PRODUCT": "product",
    "PACKAGE": "package",
    "DISCOUNT": "discount",
    "OUTSTANDING COLLECTION": "outstandings",
    "TOTAL": "total",
}

const exportCommissionStaffByDateTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "SERVICE": "service",
    "PRODUCT": "product",
    "PACKAGE": "package",
    "OUTSTANDING COLLECTION": "outstandings",
    "TOTAL": "total",
}

const exportRewardQRTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "TITLE": "title",
    "OUTLET": "outlet",
    "MEMBER NAME": "memberName",
    "MOBILE": "mobile", 
}

const exportCreditListTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "ORDER ID": "orderID",
    "NAME": "name",
    "MOBILE": "mobile",
    "ACTION": "action",
    "AMOUNT": "amount",
    "BALANCE": "balance",
    "OUTLET": "outlet",
}

const exportCreditSummaryCustomerTblHdr = {
    "NO.": "index",
    "NAME": "name",
    "MOBILE": "mobile",
    "BALANCE": "balance",
}

const exportCreditSummaryDateTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "TOP UP": "topup",
    "REDEEM": "redeem",
    "BALANCE": "balance",
}

const exportOutstandingsSummaryDateTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "OUTSTANDINGS": "outstandings",
    "COLLECTION": "collection",
    "BALANCE": "balance",
}

const exportPointsListTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "ORDER ID": "orderID",
    "NAME": "name",
    "MOBILE": "mobile",
    "ACTION": "action",
    "POINT": "point",
    "BALANCE": "balance",
    "OUTLET": "outlet",
}

const exportStockBalanceTblHdr = {
    "NO.": "index",
    "NAME": "name",
    "CATEGORY": "category",
    "SUB-CATEGORY": "subCategory",
    "BALANCE": "balance",
    "COST": "cost",
    "PRICE": "price",
    "TOTAL PRICE": "total",
}

const exportStockTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "ORDER NUMBER": "orderNumber",
    "TITLE": "title",
    "ACTION": "action",
    "CATEGORY": "category",
    "SUB-CATEGORY": "subCategory",
    "COST": "cost",
    "PRICE": "price",
    "QUANTITY": "quantity",
    "TOTAL PRICE": "total",
    "BALANCE": "balance",
}

const exportBrandChecklistTblHdr = {
    "NO.": "index",
    "TITLE": "title",
    "CATEGORY": "category",
    "ENABLE/DISABLE": "isEnable",
}

const exportDiscountTblHdr = {
    "NO.": "index",
    "TITLE": "title",
    "PRICE": "price",
    "CATEGORY": "category",
    "SUB-CATEGORY": "subCategory",
    "ENABLE/DISABLE": "isEnable",
}

const exportMenuSubCategoryTblHdr = {
    "NO.": "index",
    "TITLE": "title",
    "CATEGORY": "category",
    "ENABLE/DISABLE": "isEnable",
}

const exportPackageTblHdr = {
    "NO.": "index",
    "TITLE": "title",
    "PRICE": "price",
    "BASE PRICE": "basePrice",
    "CATEGORY": "category",
    "ENABLE/DISABLE": "isEnable",
} 

const exportProductTblHdr = {
    "NO.": "index",
    "TITLE": "title",
    "PRICE": "price",
    "BASE PRICE": "basePrice",
    "CATEGORY": "category",
    "SUB-CATEGORY": "subCategory",
    "ENABLE/DISABLE": "isEnable",
}

const exportServiceTblHdr = {
    "NO.": "index",
    "TITLE": "title",
    "PRICE": "price",
    "BASE PRICE": "basePrice",
    "CATEGORY": "category",
    "SUB-CATEGORY": "subCategory",
    "DURATION": "duration",
    "ENABLE/DISABLE": "isEnable",
    "Online": "showOnline",
}

const exportRewardTblHdr = {
    "NO.": "index",
    "QR CODE": "qrCode",
    "REWARD": "reward",
    "DURATION": "duration",
    "PROGRESS": "progress",
    "ENABLE/DISABLE": "isEnable"
}

const exportOutletTblHdr = {
    "NO.": "index",
    "BUSINESS NAME": "bizName",
    "LOCATION": "location",
    "CITY": "city",
    "USERNAME": "userName",
    "CONTACT": "contact",
    "ENABLE/DISABLE": "isEnable"
}

const exportStaffTblHdr = {
    "NO.": "index",
    "NAME": "name",
    "CONTACT": "contact",
    "SHOW FOR ONLINE": "online",
    "SHOW FOR WORKSHEET": "worksheet",
    "SHOW FOR APPOINTMENT": "appointment",
}

const exportBroadcastTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "TOPIC": "topic",
    "CAPTION": "caption",
    "LIKE": "like",
    "COMMENT": "comment",
    "REWARD QR": "rewardQR",
    "REWARD PERIOD": "rewardPeriod",
    "REWARD STATUS": "rewardStatus",
}

const exportBookingBlockListTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "MOBILE": "mobile",
}

const exportVoucherDetailsTblHdr = {
    "NO.": "index",
    "NAME": "name",
    "MOBILE": "mobile",
    "AMOUNT": "amount",
    "BALANCE": "balance",
}

const exportVoucherSummaryDateTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "SIGN UP": "signup",
    "REDEEM": "redeem",
    "EXPIRED": "expired",
}

const exportVoucherSummaryVoucherTblHdr = {
    "NO.": "index",
    "VOUCHER": "voucher",
    "BALANCE": "balance",
}

const exportVoucherSummaryExpiryTblHdr = {
    "NO.": "index",
    "VOUCHER": "voucher",
    "NAME": "name",
    "MOBILE": "mobile",
    "EXPIRY DATE": "expiry",
}

const exportVoucherSummaryCustomerTblHdr = {
    "NO.": "index",
    "NAME": "name",
    "MOBILE": "mobile",
    "VOUCHER": "voucher",
    "TOTAL": "total",
    "AMOUNT": "amount",
}

const exportVoucherListTblHdr = {
    "NO.": "index",
    "SIGN UP DATE": "signupDate",
    "REDEEM DATE": "redeemDate",
    "EXPIRED DATE": "expiredDate",
    "VOUCHER": "voucher",
    "TYPE": "type",
    "UNIT PRICE": "unitPrice",
    "MEMBER NAME": "memberName",
    "MOBILE": "mobile",
    "ORDER ID": "orderID",
    "ACTION": "action",
    "EXPIRY DATE": "expiryDate",
    "SIGN UP OUTLET": "outlet",
    "REDEEM/EXPIRED OUTLET": "redeemOutlet",
}

const exportAttendanceListTblHdr = {
    "NO.": "index",
    "NAME": "name",
    "USERNAME": "username",
    "OUTLET": "outlet",
    "WORKING HOURS": "duration",
    "CLOCK IN": "entryDate",
    "CLOCK OUT": "exitDate",
}

const exportUserListTblHdr = {
    "NO.": "index",
    "SHOP NAME": "shopname",
    "USERNAME": "username",
    "MOBILE": "mobile",
    "LOGIN DATE": "loginDate",
    "BLOCK DATE": "blockDate",
}

const exportRewardReportTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "OUTLET": "outlet",
    "REWARD": "rewardTitle",
    "NAME": "name",
    "MOBILE": "mobile",
}

const exportOrderReportTblHdr = {
    "NO.": "index",
    "DATE": "date",
    "RECEIPT NO.": "receiptNumber",
    "OUTLET": "outlet",
    "STAFFS": "staffs",
    "INFO NAME": "infoName",
    "MOBILE": "mobile",
    "ITEM": "items",
    "PAYMENT METHODS": "paymentMethod",
    "TAX": "tax",
    "ROUNDING": "rounding",
    "TOTAL": "total",
}

export default{
    exportMemberDeleteTblHdr: exportMemberDeleteTblHdr,
    exportMemberChangeMobileTblHdr: exportMemberChangeMobileTblHdr,
    exportCommissionItemTblHdr: exportCommissionItemTblHdr,
    exportCommissionTypeTblHdr: exportCommissionTypeTblHdr,
    exportCommissionCategoryTblHdr: exportCommissionCategoryTblHdr,
    exportMemberActiveTblHdr: exportMemberActiveTblHdr, 
    exportSalesReportItemTblHdr: exportSalesReportItemTblHdr, 
    exportSalesReportDateTblHdr: exportSalesReportDateTblHdr,
    exportRewardQRTblHdr: exportRewardQRTblHdr,
    exportCreditListTblHdr: exportCreditListTblHdr, 
    exportCreditSummaryCustomerTblHdr: exportCreditSummaryCustomerTblHdr, 
    exportCreditSummaryDateTblHdr: exportCreditSummaryDateTblHdr,
    exportStockBalanceTblHdr: exportStockBalanceTblHdr,
    exportStockTblHdr: exportStockTblHdr,
    exportBrandChecklistTblHdr: exportBrandChecklistTblHdr,
    exportDiscountTblHdr: exportDiscountTblHdr,
    exportMenuSubCategoryTblHdr: exportMenuSubCategoryTblHdr,
    exportPackageTblHdr: exportPackageTblHdr, 
    exportProductTblHdr: exportProductTblHdr,
    exportServiceTblHdr: exportServiceTblHdr,
    exportRewardTblHdr: exportRewardTblHdr, 
    exportOutletTblHdr: exportOutletTblHdr,
    exportStaffTblHdr: exportStaffTblHdr,
    exportBroadcastTblHdr:  exportBroadcastTblHdr,
    exportOutstandingsSummaryDateTblHdr: exportOutstandingsSummaryDateTblHdr, 
    exportPointsListTblHdr: exportPointsListTblHdr,
    exportBookingBlockListTblHdr: exportBookingBlockListTblHdr,
    exportVoucherSummaryDateTblHdr: exportVoucherSummaryDateTblHdr, 
    exportVoucherSummaryVoucherTblHdr: exportVoucherSummaryVoucherTblHdr,
    exportVoucherSummaryCustomerTblHdr: exportVoucherSummaryCustomerTblHdr,
    exportVoucherListTblHdr: exportVoucherListTblHdr,
    exportAttendanceListTblHdr: exportAttendanceListTblHdr,
    exportVoucherSummaryExpiryTblHdr: exportVoucherSummaryExpiryTblHdr,
    exportUserListTblHdr: exportUserListTblHdr, 
    exportRewardReportTblHdr: exportRewardReportTblHdr,
    exportVoucherDetailsTblHdr: exportVoucherDetailsTblHdr, 
    exportOrderReportTblHdr: exportOrderReportTblHdr,
    exportCommissionStaffByDateTblHdr: exportCommissionStaffByDateTblHdr
}